export class ValidateClaudeEnterpriseKeyRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "complianceAccessKey",
            "baseName": "complianceAccessKey",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ValidateClaudeEnterpriseKeyRequest.attributeTypeMap;
    }
    constructor() {
    }
}
